import { VonAccessRights } from "../../../../Constants/VON/EmployeeForm/vonAccessRights";
import { VonEmployeeTypes } from "../../../../Constants/VON/EmployeeForm/vonEmployeeTypes";
import { RadioButtons } from "../../../FormComponents/RadioButtons";
import { useTranslation } from "react-i18next";
import { Companies } from "../../../../Constants/companies";

const VonEditAccessRightsForm = ({ form, onChange, isBankruptcyTrustee, hasOtherBankruptcyTrustees }) => {
    const { t } = useTranslation();
    const { data } = form;
    const isDisabled = data.isPrimaryContact || data.newMainContactId != null;
    const isDeleteDisabled = isBankruptcyTrustee && !hasOtherBankruptcyTrustees;

    const onChangeAccessRight = (value) => {
        if (value !== VonAccessRights.Administrator) {
            onChange(form.id, null, "newMainContactId");
        }
        onChange(form.id, value, 'onlineRoleId');
    }

    let radioButtons = [
        { id: 'access-type-1', label: t('voneditaccessrightsform.admindescription'), disabled: data.employeeTypeId == VonEmployeeTypes.Auditor, value: VonAccessRights.Administrator },
        { id: 'access-type-2', label: t('voneditaccessrightsform.userdescription'), value: VonAccessRights.User, disabled: isBankruptcyTrustee || data.employeeTypeId == VonEmployeeTypes.BankruptcyTrustee },
        { id: 'access-type-3', label: t('voneditaccessrightsform.inactivedescription', { companyName: Companies.Spiris }), value: VonAccessRights.Inactive },
        { id: 'access-type-4', label: t('voneditaccessrightsform.deletedescription'), disabled: isDeleteDisabled, value: VonAccessRights.Delete }
    ]

    return <div>
        <fieldset className="d-grid col gap-16 mb-0" disabled={isDisabled}>
            <legend>{t('voneditaccessrightsform.title', { companyName: Companies.Spiris })}</legend>
            <div className="d-grid gap-8">
                <RadioButtons items={radioButtons} onChange={(value) => onChangeAccessRight(value)} value={data.onlineRoleId} />
            </div>
        </fieldset>
    </div>
}

export default VonEditAccessRightsForm;